.profileItemContent {
  max-width: unset;
}

.workforceMemberButton {
  white-space: normal;
  text-align: left;
}
